import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aedda34e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-text" }, " Enhancing your image, this may take a moment... ", -1))
const _hoisted_4 = { class: "image-inner" }
const _hoisted_5 = {
  key: 0,
  class: "original-badge"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "button-row"
}
const _hoisted_8 = { class: "left-buttons" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-arrow-rotate-left" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "ai-disclaimer"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, " Artificial Intelligence can make mistakes. Please ensure you check before using the output. ", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "right-buttons" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-arrow-left-arrow-right" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-copy" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-download" }, null, -1))

import { computed, onUnmounted, ref, watch } from "vue";
import DxLoadIndicator from "devextreme-vue/load-indicator";
import { DxButton } from "devextreme-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-image-display',
  props: {
  /**
   * The URL for the original image.
   * Used to display the original image.
   * @type {String}
   * @required
   */
  originalImageAsURL: {
    type: String,
    required: true,
  },

  /**
   * The The URL for the generated image.
   * Used to display the response image.
   * @type {String}
   * @default
   */
  aiImageAsURL: {
    type: String,
    default: null,
  },

  /**
   * If the API is currently generating the image
   * Used to apply class to the image while generating
   * @type {Boolean}
   * @required
   */
  waitingForAiApi: {
    type: Boolean,
    required: true,
  },

  /**
   * The width of the image container.
   * Controls how much horizontal space the image occupies.
   * @type {string}
   * @default '100%'
   */
  imageWidth: {
    type: String,
    default: "100%",
  },

  /**
   * The height of the image container.
   * Defines the vertical space the image should take.
   * @type {string}
   * @default 'unset'
   */
  imageHeight: {
    type: String,
    default: "unset",
  },

  /**
   * Defines how the image should be resized to fit its container.
   * Common values: `cover`, `contain`, `fill`, or `none`.
   * @type {string}
   * @default 'unset'
   */
  objectFit: {
    type: String,
    default: "unset",
  },

  /**
   * The maximum height the image can have.
   * Prevents images from exceeding a certain vertical size.
   * @type {string}
   * @default 'unset'
   */
  maxImageHeight: {
    type: String,
    default: "unset",
  },

  /**
   * The top and bottom padding around the image.
   * Helps adjust spacing without affecting width and height.
   * @type {string}
   * @default "0rem"
   */
  topBottomPadding: {
    type: String,
    default: "0rem",
  },
},
  emits: [
  /**
   * Triggered when the user clicks to copy the AI result
   * @event copyImage
   */
  "copyImage",

  /**
   * Triggered when the user clicks to download the AI result
   * @event downloadImage
   */
  "downloadImage",

  /**
   * Triggered when the user clicks to undo the last generation.
   * @event undoEnhancement
   */
  "undoEnhancement",
],
  setup(__props, { emit }) {

const props = __props;



const showingAI = ref(false);

const displayedImage = computed(() => {
  if (showingAI.value && props.aiImageAsURL) {
    return props.aiImageAsURL;
  }
  return props.originalImageAsURL;
});

const toggleImage = () => {
  showingAI.value = !showingAI.value;
};

const copyToClipboard = async () => {
  emit("copyImage");
};

const downloadImage = () => {
  emit("downloadImage");
};

const clearAIImage = () => {
  emit("undoEnhancement");
};



watch(
  () => props.aiImageAsURL,
  (value) => {
    if (value !== "") showingAI.value = true;
    else showingAI.value = false;
  },
);

onUnmounted(() => {
  // To ensure the pictures are not left hanging in browser memory, call revokeObjectUrl to delete the cached images
  if (props.originalImageAsURL != "") {
    windowUrl.value.revokeObjectURL(props.originalImageAsURL);
  }
  if (props.aiImageAsURL != "") {
    windowUrl.value.revokeObjectURL(props.aiImageAsURL);
  }
});

const imgClass = computed(() => {
  if (props.waitingForAiApi) return "blurred";
  if (props.aiImageAsURL != "" && !showingAI.value) return "original-outline";
  return "";
});

// Webkit browser support webkitURl (chrome firefox) the other class caters for browsers that don't (not sure if there are any but did it just incase)
const windowUrl = computed(() => window.webkitURL || window.URL);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "picture-container",
    style: _normalizeStyle({
      '--image-width': props.imageWidth,
      '--image-height': props.imageHeight,
      '--max-image-height': props.maxImageHeight,
      '--object-fit': props.objectFit,
      '--top-bottom-padding': props.topBottomPadding,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (props.waitingForAiApi)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(DxLoadIndicator), {
              height: 40,
              width: 40
            }),
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (props.aiImageAsURL != '' && !showingAI.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Original "))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          src: displayedImage.value,
          class: _normalizeClass(imgClass.value)
        }, null, 10, _hoisted_6)
      ])
    ]),
    (props.aiImageAsURL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(DxButton), {
              class: "button-left button-row-button",
              onClick: clearAIImage,
              hint: "Undo last enhancement",
              disabled: __props.waitingForAiApi
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          (__props.aiImageAsURL !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(DxButton), {
              class: "button-right button-row-button",
              onClick: toggleImage,
              hint: "Toggle original / AI",
              disabled: __props.waitingForAiApi
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(DxButton), {
              class: "button-right button-row-button",
              onClick: copyToClipboard,
              hint: "Copy to clipboard",
              disabled: __props.waitingForAiApi
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(DxButton), {
              class: "button-right button-row-button",
              onClick: downloadImage,
              hint: "Download",
              disabled: __props.waitingForAiApi
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})